

import axios from "axios";
import requestErrorHandler from "./requestErrorHandler";
// import { store } from "redux/store";
const axiosConfig = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});
axiosConfig.interceptors.request.use(
  function (config:any) {
    const token = localStorage.getItem("token");
    // const {token}= useAuth()
    // if (!token) return Promise.reject("unAuthorized");
    const headers = {
      Authorization: `Bearer ${token ?? ''}`,
    };
    config.headers = headers!;
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

axiosConfig.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);

export async function fetcher({url, args}: {url: string, args?: any}) {
  const response = await axiosConfig.get(url, { params: {...args } });
  return response.data;
}

export const handleMutation = async (url:string, {arg}:{arg: any}) => {
  try {
    const {data} = await axiosConfig.post(url, arg)
    return data
  } catch (error) {
    requestErrorHandler(error)
  }
}

export const handleUpdates = async (url:string, {arg}:{arg: any}) => {
  try {
    const {data} = await axiosConfig.put(url, arg)
    return data
  } catch (error) {
    requestErrorHandler(error)
  }
}

export default axiosConfig;



